import z from 'zod'
import {
  firestoreTimestamp,
  nullSafeOptionalFirestoreTimestamp,
  nullSafeOptionalString,
} from '../shared/schema'

export const schema = z.object({
  rubricId: z.string(),
  startedAt: nullSafeOptionalFirestoreTimestamp(),
  endedAt: firestoreTimestamp.nullable(),
  promptVersionId: nullSafeOptionalString(), // used when specifying specific prompt version id to test
  rubricTestId: z.string().nullable(),
})

export const empty = Object.freeze(
  schema.parse({
    rubricId: '',
    endedAt: null,
    promptVersionId: null,
    rubricTestId: null,
  })
)

export type FirestoreSlideDeckRubricAI = z.infer<typeof schema>
